export const SORT_OPTIONS = {
	RECOMMENDATION: { id: "recommendation", labelKey: "sort.types.recommended" },
	PRICE_ASC: { id: "price_asc", labelKey: "sort.types.price.asc" },
	PRICE_DESC: { id: "price_desc", labelKey: "sort.types.price.desc" },
	RATING_DESC: { id: "rating_desc", labelKey: "sort.types.tripadvisor" },
	STARS_DESC: { id: "stars_desc", labelKey: "sort.types.stars" },
};
